module.exports = __webpack_public_path__ + "assets/images/arrow-left.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/arrow-left.png
// module id = 1481
// module chunks = 1